import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UsersIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "8",
    cy: "8",
    r: "3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.06,13a7,7,0,0,0-6.93,6A.88.88,0,0,0,2,20H14.12A.87.87,0,0,0,15,19,7,7,0,0,0,8.06,13Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "16",
    cy: "8",
    r: "3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.06,13a7,7,0,0,0-2,.3A9,9,0,0,1,17,18.72,2.9,2.9,0,0,1,16.86,20h5.26A.87.87,0,0,0,23,19,7,7,0,0,0,16.06,13Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.06,13a7,7,0,0,0-6.93,6A.88.88,0,0,0,2,20H14.12A.87.87,0,0,0,15,19,7,7,0,0,0,8.06,13Z"
  })]
}), 'UsersIcon');